export enum DocumentParentType {
	Eligibility = 1,
	Phase = 2,
	Case = 3,
	Generated = 4,
}